"use client";

import { useSyncExternalStore } from "react";
import { createPortal } from "react-dom";

const subscribe = () => () => {};

/** The structured-data script of a legal page, written into the document `<head>` (a portal; the server stream cannot put it there because the page's data is read after the head is sent). It appears once the browser has built the page, which search engines that render pages read. */
export function HeadJsonLd({ json }: { json: string }) {
  const inBrowser = useSyncExternalStore(subscribe, () => true, () => false);
  return inBrowser ? createPortal(<script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }} />, document.head) : null;
}
